import { get, post, put } from "./divertidogsApiUtils";
import { useQuery } from "@tanstack/react-query";

export interface Unidad {
  id: string;
  nombre: string;
}

export interface ItemListadoProductos {
  id: string;
  nombre: string;
  descripcion?: string;
  unidad: string;
  precioUnitario: number;
}

export const listarProductos = async (): Promise<
  ItemListadoProductos[] | undefined
> => {
  return get<ItemListadoProductos[]>(`productos`);
};

export const QUERY_KEY_LISTAR_PRODUCTOS = "listar_productos";

export const useListarProductos = () => {
  return useQuery(
    [QUERY_KEY_LISTAR_PRODUCTOS],
    async () => await listarProductos()
  );
};

export interface NuevoProducto {
  nombre: string;
  descripcion?: string;
  idUnidad: string;
  precioUnitario: number;
}

export const crearProducto = async (
  nuevoServicioHotel: NuevoProducto
): Promise<undefined> => {
  return post<NuevoProducto, any | undefined>("productos", nuevoServicioHotel);
};

export interface Producto {
  id: string;
  nombre: string;
  descripcion?: string;
  unidad: Unidad;
  precioUnitario: number;
}

export const buscarProducto = async (
  id: string
): Promise<Producto | undefined> => {
  return get<Producto>(`productos/${id}`);
};

export const QUERY_KEY_BUSCAR_PRODUCTO = "buscar_producto";

export const useBuscarProducto = (id?: string) => {
  if (!id) {
    throw Error("Id de producto no definido");
  }
  return useQuery(
    [QUERY_KEY_BUSCAR_PRODUCTO],
    async () => await buscarProducto(id)
  );
};

export interface ProductoModificado {
  id: string;
  nombre: string;
  descripcion?: string;
  idUnidad: string;
  precioUnitario: number;
}

export const reemplazarProducto = async (producto: ProductoModificado) => {
  return put<ProductoModificado, undefined>(`productos`, producto);
};

export const QUERY_KEY_LISTAR_UNIDADES = "QUERY_KEY_LISTAR_UNIDADES";

export const listarUnidades = async (): Promise<Unidad[] | undefined> => {
  return get<Unidad[]>(`productos/unidades`);
};

export const useListarUnidades = () => {
  return useQuery(
    [QUERY_KEY_LISTAR_UNIDADES],
    async () => await listarUnidades()
  );
};
